import { IonCol, IonRow } from "@ionic/react";
import React, { FC } from "react";
import IntervalDataGraph from "./IntervalDataGraph";
import { format, parseISO } from 'date-fns';

interface IProps {
    hourly: any,
    daily: any,
    weekly: any,
    cols:number,
    units:string
};

const IntervalDataRow:FC<IProps> = (props) => {
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';
    
    const formatDateRange = (startTime?: string, endTime?: string, hourly?:boolean) => {
        if (!startTime || !endTime) return 'No date available';
        if(!hourly) {
            return `${format(parseISO(startTime.replace('Z', '')), 'M/d/yy')} - ${format(parseISO(endTime.replace('Z', '')), 'M/d/yy')}`;
        }
        return `${
            ( new Date(startTime)).toLocaleString(
                "en-US", {
                    month: "numeric",
                    day: "numeric",
                    year: "2-digit",
                    hour: "numeric",
                    hour12: true,
                }
                )
        } - ${
            ( new Date(endTime)).toLocaleString(
                    
                "en-US", {
                    month: "numeric",
                    day: "numeric",
                    year: "2-digit",
                    hour: "numeric",
                    hour12: true,
                }
                )
        }`
    };

    return <IonRow class="ion-justify-content-center" >
        <IonCol size="12" sizeMd={`${12/props.cols}`} style={{ minHeight:'450px' }}>
        <div className={newUI ? "bg-white" : ""}  style={{margin:'0.2rem',borderRadius:'0.5rem'}}>
            <h3 className={newUI ? 'text-dark-blue':''} style={{textAlign:'center', marginBottom:'0'}}> Day </h3>
            <h5 
            style={{textAlign:'center',
                marginTop:'0'
            }}
            >({formatDateRange(props.hourly?.start_time,props.hourly?.end_time,true)})</h5>
            <IntervalDataGraph data={props.hourly.data} units={props.units} type="hourly"/>
            </div>
        </IonCol>
        <IonCol size="12" sizeMd={`${12/props.cols}`} style={{ minHeight:'450px'}}>
        <div className={newUI ? "bg-white" : ""}  style={{margin:'0.2rem',borderRadius:'0.5rem'}}>
            <h3 className={newUI ? 'text-dark-blue':''} style={{textAlign:'center', marginBottom:'0'}}> Week </h3>
            <h5 
            style={{textAlign:'center',
                marginTop:'0'
            }}
            >({formatDateRange(props.daily?.start_time, props.daily?.end_time)})</h5>
            <IntervalDataGraph data={props.daily.data} units={props.units} type="daily"/>
            </div>
        </IonCol>
        <IonCol size="12" sizeMd={`${12/props.cols}`} style={{ minHeight:'450px' }}>
        <div className={newUI ? "bg-white" : ""}  style={{margin:'0.2rem',borderRadius:'0.5rem'}}>
            <h3 className={newUI ? 'text-dark-blue':''} style={{textAlign:'center', marginBottom:'0'}}> Month </h3>
            <h5 
            style={{textAlign:'center',
                marginTop:'0'
            }}
            >({formatDateRange(props.weekly?.start_time, props.weekly?.end_time)})</h5>

            <IntervalDataGraph data={props.weekly.data} units={props.units} type="weekly" />
            </div>
        </IonCol>
    </IonRow>
};

export default IntervalDataRow;